import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { LoadingComponent } from './components/loading/loading.component';
import { TmAuthCallbackComponent } from './components/providers/tm/tm-auth-callback/tm-auth-callback.component';
import { MarkdownTranslatePipe } from './pipes/markdown-translate.pipe';
import { TermsAndConditionsModule } from '@fgb/portal-component-library/src/lib/club/terms-and-conditions';
import { FaqSectionModule } from '@fgb/portal-component-library/src/lib/club/faq-section';
import { PipesModule } from '@fgb/portal-component-library/src/lib/pipes';
import { FGBSharedModule } from '@fgb/portal-component-library/src/lib/shared';

@NgModule({
  declarations: [LoadingComponent, TmAuthCallbackComponent, MarkdownTranslatePipe],
  imports: [
    ReactiveFormsModule,
    FormsModule,
    CommonModule,
    NgbModule,
    RouterModule,
    PipesModule,
    FGBSharedModule,
    TermsAndConditionsModule,
    FaqSectionModule,
  ],
  exports: [
    LoadingComponent,
    MarkdownTranslatePipe,
    TermsAndConditionsModule,
    FaqSectionModule,
    PipesModule,
  ],
})
export class SharedModule {}
